import { createTheme } from "@mui/material/styles";

function createGradient(color1, color2) {
  return `linear-gradient(135deg, ${color1} 0%, ${color2} 100%)`;
}

const redPalette = {
  background: {
    paper: "transparent",
    // default: "transparent",
  },
  primary: {
    main: "#BC060B",
  },

  secondary: {
    main: "#323232",
  },

  text: {
    primary: "#fff",
    secondary: "#323232",
  },
  gradient: createGradient("#323232", "#fff"),
};
const lillacPalette = {
  background: {
    paper: "transparent",
    // default: "transparent",
  },
  primary: {
    main: "#6890BB",
  },

  secondary: {
    main: "#48566A",
  },
  text: {
    primary: "#fff",
    secondary: "#4E565E",
  },
  tertiary: "#5866BC",

  gradient: createGradient("#4E565E", "#fff"),
};

const lightBluePalette = {
  background: {
    paper: "transparent",
    // default: "transparent",
  },
  primary: {
    main: "#0583CC",
  },
  secondary: {
    main: "#323232",
  },
  text: {
    primary: "#fff",
    secondary: "#9accfa",
  },

  gradient: createGradient("#9accfa", "#fff"),
};

const typography = {
  fontFamily: "'Poppins', Arial, sans-serif",
  fontSize: 16,
  secondaryFontFamily: "Jura, sans-serif",
  h1: {
    fontSize: "34px",
  },
  h2: {
    fontSize: "32px",
  },
  h3: {
    fontSize: "26px",
  },
  h4: {
    fontSize: "24px",
  },
  h5: {
    fontSize: "22px",
  },
  h6: {
    fontSize: "20px",
  },
};
const shape = {
  borderRadius: 4,
  borderRadiusSecondary: 16,
};
const space = {
  main: "1rem",
  half: "0.5rem",
  quarter: "0.25rem",
  double: "2rem",
  triple: "3rem",
  quadruple: "4rem",
};
const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 900,
    lg: 1280,
    xl: 1920,
  },
};

const components = {
  MuiInputLabel: {
    styleOverrides: {
      root: {
        color: "#fff",
      },
    },
  },
  MuiDateCalendar: {
    styleOverrides: {
      root: {
        borderRadius: "0px",
        borderWidth: "0px",
        borderColor: "#2196f3",
        border: "0px solid",
        backgroundColor: "var(--bkg-light)",
        ".Mui-selected": {
          backgroundColor: "var(--main-color)",
        },
        "& .MuiPickersDay-root.Mui-selected": {
          backgroundColor: "var(--main-color) !important",
          "&:hover": {
            backgroundColor: "var(--main-color)",
          },
        },
      },
    },
  },
};

export const design1Theme = createTheme({
  palette: redPalette,
  typography: typography,
  shape: shape,
  space: space,
  breakpoints: breakpoints,
  components: components,
});

export const design2Theme = createTheme({
  palette: lillacPalette,
  typography: typography,
  shape: shape,
  space: space,
  breakpoints: breakpoints,
  components: components,
});

export const design3Theme = createTheme({
  palette: lightBluePalette,
  typography: typography,
  shape: shape,
  space: space,
  breakpoints: breakpoints,
  components: components,
});
